import {Component, Host, h, Element, State, Prop} from '@stencil/core';
import Splide from '@splidejs/splide'

@Component({
  tag: 'z3-carousel',
  styleUrl: 'z3-carousel.css',
  shadow: false
})
export class Z3Carousel {

  @Element() host: HTMLElement;

  splideElement!: HTMLDivElement;
  splideListElement!: HTMLElement;
  splideElementSlot!: HTMLSlotElement;

  @State() splide: any = undefined;

  /**
   * Props
   */
  @Prop() perPageSm: number = 1;
  @Prop() perPageMd: number = 2;
  @Prop() perPageLg: number = 2;
  @Prop() perPageXl: number = 3;
  @Prop() perPage: number = 4;

  connectedCallback() {
    this.host.classList.add('load')
  }

  componentDidRender () {
    if (!this.splide && this.splideElement) {
      this.initSplide()
    }
  }

  initSplide() {
    let splide = new Splide(this.splideElement, {
      type      : 'slide',
      autoWidth: true,
      gap: '1rem',
    })
    this.splide = splide
    splide.on( 'overflow', function ( isOverflow ) {
      splide.go( 0 );
      splide.options = {
        arrows    : isOverflow,
        drag      : isOverflow,
        clones    : isOverflow ? undefined : 0,
        autoplay  : isOverflow,
      };
    });
    splide.mount();
    splide.refresh();
  }

  render() {
    return (
      <Host>
        <div class="splide" part="slide" ref={(el) => this.splideElement = el as HTMLDivElement}>
          <div class="splide__track" part="track">
            <ul class="splide__list" part="list" ref={(el) => this.splideListElement = el as HTMLElement}>
                <slot ref={(el) => this.splideElementSlot = el as HTMLSlotElement}></slot>
            </ul>
          </div>
          <div class="splide__arrows" part="arrows"></div>
        </div>
      </Host>
    );
  }

}
